import {
  CreateStakeholderGroupInput,
  GroupedStakeholderSegmentDropdownDocument,
  StakeholderListDocument,
  SurveyLanguage,
  useCreateStakeholderGroupMutation,
} from '@/graphql/generated';

import { PlusIcon } from '@/components/icons';
import { useModal } from '@/components/modals/Modal';
import { useTranslation } from '@/hooks/useTranslation';

import { StakeholderGroupForm } from '../form/StakeholderGroupForm';

type Props = {
  companyId: string;
  initialLanguage: SurveyLanguage;
};

export const AddStakeholderGroupButton = ({
  companyId,
  initialLanguage,
}: Props) => {
  const modal = useModal();
  const { t } = useTranslation();
  const [createStakeholderGroup] = useCreateStakeholderGroupMutation();

  const openCreateIroModal = () => {
    modal.openModalWithComponent(
      <StakeholderGroupForm<CreateStakeholderGroupInput>
        companyId={companyId}
        initialLanguage={initialLanguage}
        onSubmit={(input) =>
          createStakeholderGroup({
            variables: { input },
            refetchQueries: () => [
              {
                query: StakeholderListDocument,
                variables: {
                  companyId: companyId,
                },
              },
              {
                query: GroupedStakeholderSegmentDropdownDocument,
                variables: {
                  companyId: companyId,
                },
              },
            ],
          })
        }
        onClose={modal.closeModal}
      />,
      t('iro.create.modal.title'),
      false,
      false,
      undefined,
      'p-0',
    );
  };

  return (
    <button className="primary purple" onClick={openCreateIroModal}>
      <PlusIcon className="w-4 h-4" />
      {t('global:add')}
    </button>
  );
};
